import axios from 'axios';
import authHeader from "./auth-header";

class GameListService {

    getGameList (id) {
        return axios.get(window.api_url + "/api/auth/list/" + id);
    }

    addGameList (name) {
        let formData = new FormData();
        formData.append('name', name);

        return axios.post(window.api_url + "/api/auth/list/", formData, {headers: authHeader()});
    }

    addGameToList (listId, gameId) {
        return axios.put(window.api_url + "/api/auth/list/" + listId + "/" + gameId, null, {headers: authHeader()});
    }

    addGameToWishList (gameId) {
        return axios.put(window.api_url + "/api/auth/wishlist" + "/" + gameId, null, {headers: authHeader()});
    }

    removeGameFromWishList (gameId) {
        return axios.delete(window.api_url + "/api/auth/wishlist" + "/" + gameId, {headers: authHeader()});
    }

    onWishlist(gameId){
        return axios.get(window.api_url + "/api/auth/game/" + gameId + "/onWishlist", {headers: authHeader()});
    }

    getWishlist(amount){
        return axios.get(window.api_url + "/api/auth/wishlist/"+ amount, {headers: authHeader()});
    }
    getWishlistById(amount, id){
        return axios.get(window.api_url + "/api/auth/wishlist/" + id + "/" + amount, {headers: authHeader()});
    }

}

export default new GameListService();